import {
  Component,
  input,
  InputSignal,
} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {LangMenuComponent} from '../lang-menu/lang-menu.component';

@Component({
  selector: 'app-header-panel',
  imports: [TranslatePipe, LangMenuComponent],
  templateUrl: './header-panel.component.html',
  styleUrl: './header-panel.component.scss',
})
export class HeaderPanelComponent {

  public readonly logo: InputSignal<string | null> = input<string | null>('');

}
